import {
  Gender,
  ReservationRequiredField,
  RequiredFieldInput,
} from '../generated/graphql';

export const GUEST_FIELD_MAPPING = {
  [ReservationRequiredField.DodId]: 'edipi',
  [ReservationRequiredField.Rank]: 'rank',
  [ReservationRequiredField.TaskForce]: 'taskForce',
  [ReservationRequiredField.Gender]: 'gender',
  [ReservationRequiredField.EmployeeNumber]: 'employeeNumber',
  [ReservationRequiredField.Mission]: 'mission',
  [ReservationRequiredField.JobTitle]: 'jobTitle',
} as const;

export type GuestFieldNames =
  (typeof GUEST_FIELD_MAPPING)[keyof typeof GUEST_FIELD_MAPPING];

export type GuestFieldValues = {
  firstName: string;
  lastName: string;
} & {
  [K in GuestFieldNames]?: K extends 'gender' ? Gender : string;
};

export const ROOM_SPECIFIC_FIELDS = [
  ReservationRequiredField.DoorCode, // Room-specific, no design yet
];

export function isGuestSpecificField(field: ReservationRequiredField): boolean {
  return Object.keys(GUEST_FIELD_MAPPING).includes(field);
}

export function isRoomSpecificField(field: ReservationRequiredField): boolean {
  return ROOM_SPECIFIC_FIELDS.includes(field);
}

export function isBookingLevelField(field: ReservationRequiredField): boolean {
  return !isGuestSpecificField(field) && !isRoomSpecificField(field);
}

export function getOrderLevelFields(
  fields: ReservationRequiredField[],
): ReservationRequiredField[] {
  return fields.filter((field) => isBookingLevelField(field));
}

export function getGuestLevelFields(
  fields: ReservationRequiredField[],
): ReservationRequiredField[] {
  return fields.filter((field) => isGuestSpecificField(field));
}

export function initializeRequiredFieldsArray(
  clientRequiredFields: ReservationRequiredField[],
): RequiredFieldInput[] {
  const orderFields = getOrderLevelFields(clientRequiredFields);
  return orderFields.map((fieldType) => ({
    name: fieldType,
    value: null,
  }));
}
